import React, { useEffect, useState } from "react";
import { BlogHeader } from "../../../components/BlogHeader";
import { BlogBanner } from "../../../blocks/blog-home-banner";
import { BlogList } from "../../../blocks/blog-home-list";
import { BlogHomeAside } from "../../../blocks/blog-home-aside";
import "./styles.less";
import { blogAxios } from "../../../utils/blogAxios";
import { Footer } from "../../../components/FooterV2";

// import { useTranslation } from "react-i18next";

export const BlogHomePage = ({
  articleList,
  query,
  banner: serverBanner,
  categories,
  recommends,
  articleTotalCount,
}) => {
  //   const { t } = useTranslation();
  const [banner, setBanner] = useState(serverBanner);
  useEffect(() => {
    blogAxios.get("/banners").then(({ data }) => {
      setBanner(data[0]);
    });
  }, []);

  return (
    <div className="blog-home-page">
      <BlogHeader />

      {banner && <BlogBanner {...banner} />}
      <div className="blog-content">
        <BlogList
          articleTotalCount={articleTotalCount}
          categories={categories}
          articleList={articleList}
          query={query}
        />
        <BlogHomeAside recommends={recommends} />
      </div>
      <Footer />
    </div>
  );
};
